import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useStaticProps, queryParameterContext } from '../../context';

export const ProgramLevelFilter = () => {
  const programLevelsFilter = queryParameterContext.useFilterField('programLevels', 'PrimaryFilter');
  const {
    referenceData: { programLevels },
  } = useStaticProps();

  return (
    <MultiCombobox
      value={programLevelsFilter.value}
      aria-label="Program level"
      placeholder="Program level"
      onChange={(selectedItems) => programLevelsFilter.setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {Object.entries(programLevels).map(([id, { name }]) => (
        <MultiCombobox.Option label={name} value={id} key={id} />
      ))}
    </MultiCombobox>
  );
};
